var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcExpense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.80008H10C10.8284 6.80008 11.5 7.51643 11.5 8.40008M9 6.80008H8C7.17157 6.80008 6.5 7.51643 6.5 8.40008C6.5 9.28374 7.17157 10.0001 8 10.0001H10C10.8284 10.0001 11.5 10.7164 11.5 11.6001C11.5 12.4837 10.8284 13.2001 10 13.2001H9M9 6.80008V5.00008M9 13.2001H8C7.17157 13.2001 6.5 12.4837 6.5 11.6001M9 13.2001V15.0001M13 0.666748H2.33333C1.59695 0.666748 1 1.2637 1 2.00008V18.0001C1 18.7365 1.59695 19.3334 2.33333 19.3334H15.6667C16.403 19.3334 17 18.7365 17 18.0001V4.66675L13 0.666748Z",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExpense);
export default __webpack_public_path__ + "static/media/ic_expense.40c559455d33757e3f1d24efc69de86b.svg";
export { ForwardRef as ReactComponent };